export default "__VITE_ASSET__CWPjw2N2__"